import React from "react";
import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";

const LinkElement = ({
    title,
    to,
    iconComponent,
    style
}) => (
        <Link
            to={ to }
            style={style}
        >
            <Button
                color={window.location.pathname == to ? "primary" : "default"}
                variant="outlined"
            >
                { iconComponent }
                { title }
            </Button>
        </Link>
    )

export default LinkElement
